import { render, staticRenderFns } from "./KgjtWebsiteGeneralInformation.vue?vue&type=template&id=65eb5114&scoped=true&"
import script from "./KgjtWebsiteGeneralInformation.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteGeneralInformation.vue?vue&type=script&lang=js&"
import style0 from "./KgjtWebsiteGeneralInformation.vue?vue&type=style&index=0&id=65eb5114&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eb5114",
  null
  
)

export default component.exports